const RAWBT_VALUES = new Set([
  "1",
  "true",
  "yes",
  "si",
  "rawbt",
  "raw-bt",
  "escpos",
  "esc/pos",
  "thermal",
  "termica",
  "android",
]);

const BROWSER_VALUES = new Set([
  "0",
  "false",
  "no",
  "browser",
  "html",
  "pdf",
  "dialog",
  "system",
  "navegador",
]);

function normalizeDriverValue(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

function getRuntimeDriverOverride() {
  if (typeof window === "undefined") return "";

  try {
    const params = new URLSearchParams(window.location.search);
    const queryValue =
      params.get("printDriver") ||
      params.get("printer") ||
      params.get("impresora");

    const storedValue =
      window.localStorage.getItem("printDriver") ||
      window.localStorage.getItem("printerDriver") ||
      window.localStorage.getItem("impresora");

    if (queryValue) {
      window.localStorage.setItem("printDriver", queryValue);
      return queryValue;
    }

    return storedValue || "";
  } catch {
    return "";
  }
}

export function getConfiguredPrintDriver() {
  const envValue =
    process.env.REACT_APP_PRINT_DRIVER ||
    process.env.REACT_APP_PRINTER_DRIVER ||
    "";
  const value = normalizeDriverValue(getRuntimeDriverOverride() || envValue);

  if (RAWBT_VALUES.has(value)) return "rawbt";
  if (BROWSER_VALUES.has(value)) return "browser";

  return "";
}

export function isAndroidLikeDevice() {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent || "";
  const platform = navigator.userAgentData?.platform || navigator.platform || "";
  const uaAndPlatform = `${ua} ${platform}`;

  if (/Android/i.test(uaAndPlatform)) return true;

  // Chrome on Android tablets can hide "Android" when desktop site is enabled.
  const touchPoints = Number(navigator.maxTouchPoints || 0);
  return (
    touchPoints > 1 &&
    /Linux/i.test(uaAndPlatform) &&
    /Chrome|Chromium/i.test(ua) &&
    !/CrOS|Windows|Macintosh|iPad|iPhone/i.test(uaAndPlatform)
  );
}

export function shouldUseRawBT() {
  const configuredDriver = getConfiguredPrintDriver();

  if (configuredDriver) return configuredDriver === "rawbt";

  return isAndroidLikeDevice();
}
